import React,{ useEffect ,useState,useRef} from "react";
import "./index.css";
import "../../common/css/common.css";
import { Link } from "react-router-dom";

import { useSelector, useDispatch } from "react-redux";
import {setHeader} from "../../redux/actions/header_length";
import { logout } from "../../redux/actions/JWTAuth_action";
// import { useSelector } from "react-redux";


function Header(){
    const offset = useSelector((state)=>state.headerReducer);
    const auth = useSelector((state)=>state.jwtAuthreducer);
    const current_nav = useRef(false)
    const [mobilemenu,setmobilmenu] = useState(false)
    const dispatch = useDispatch();
    useEffect(()=>{
        const onScroll = ()=>dispatch(setHeader({ type: "HEADER_LENGTH", payload: window.pageYOffset }));        
        window.removeEventListener('scroll',onScroll);
        window.addEventListener('scroll',onScroll);
        return () => window.removeEventListener('scroll', onScroll);
    });
    const reset = ()=>{
        dispatch(logout());
    }

    const mobileMenu = ()=>{
        if(current_nav.current){
            current_nav.current = false;
        }
        else{
            current_nav.current =true
        }
        setmobilmenu(current_nav.current)
    }
   

    return (
        <header className={offset.status.payload ? "header fix":"header"} id="temp_header">
            <div className="container d-flex align-items-center">
                <a href="#" className="logo">
                    <img src={process.env.PUBLIC_URL + "/img/bedater-logo.png"} alt="" title="" width="86" />
                </a>
                <div className="ml-auto d-flex align-items-center">
                    <nav className={mobilemenu === false ? "":"show"}>
                        <a href="#aboutSection">About</a>
                        <a href="#howItWorksSection">How It Works</a>
                        <a href="#">Contact Us</a>
                        {auth.user ? <Link onClick={()=>reset()} >Logout</Link> : <Link to="/login">Login / Sign Up</Link>}
                        {auth.user ? <a style = {{fontweight:"bold"}}>Hi  {auth.user.username} !</a>:""}
                    </nav>
                    <div className={ mobilemenu === false ?"overlay":"overlay show"}></div>
                    <Link to="/event" className="btn btn-gradient d-none d-lg-flex">
                        <svg className="mr-3" width="16" height="24" viewBox="0 0 16 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15.4073 6.23389C15.0814 6.23389 14.8147 6.51441 14.8147 6.85727V11.5326C14.8147 15.4911 11.7628 18.7015 7.99988 18.7015C4.23692 18.7015 1.18506 15.4911 1.18506 11.5326V6.85727C1.18506 6.51441 0.918396 6.23389 0.592471 6.23389C0.266545 6.23389 -0.00012207 6.51441 -0.00012207 6.85727V11.5326C-0.00012207 15.9586 3.25914 19.6054 7.40729 19.9171V22.7535H4.14803C3.8221 22.7535 3.55543 23.034 3.55543 23.3769C3.55543 23.7197 3.8221 24.0002 4.14803 24.0002H12.4443C12.7702 24.0002 13.0369 23.7197 13.0369 23.3769C13.0369 23.034 12.7702 22.7535 12.4443 22.7535H8.59247V19.9171C12.7406 19.6054 15.9999 15.9586 15.9999 11.5326V6.85727C15.9999 6.51441 15.7332 6.23389 15.4073 6.23389Z" fill="white"></path>
                            <path d="M7.99987 16.8313C10.7851 16.8313 13.0369 14.4624 13.0369 11.5325V5.29874C13.0369 2.36885 10.7851 0 7.99987 0C5.21468 0 2.96283 2.36885 2.96283 5.29874V11.5325C2.96283 14.4624 5.21468 16.8313 7.99987 16.8313ZM4.14801 10.2858H7.70357C8.0295 10.2858 8.29616 10.0053 8.29616 9.66241C8.29616 9.31955 8.0295 9.03903 7.70357 9.03903H4.14801V7.79226H7.70357C8.0295 7.79226 8.29616 7.51174 8.29616 7.16888C8.29616 6.82602 8.0295 6.5455 7.70357 6.5455H4.14801V5.29874H7.70357C8.0295 5.29874 8.29616 5.01822 8.29616 4.67536C8.29616 4.3325 8.0295 4.05198 7.70357 4.05198H4.32579C4.8295 2.43119 6.28135 1.24676 7.99987 1.24676C10.1332 1.24676 11.8517 3.05457 11.8517 5.29874V11.5325C11.8517 13.7767 10.1332 15.5845 7.99987 15.5845C5.86653 15.5845 4.14801 13.7767 4.14801 11.5325V10.2858Z" fill="white"></path>
                        </svg>
                        Join Event
                    </Link>
                    <span onClick={()=>mobileMenu()} aria-label="Close" className={mobilemenu === false ? "hamburgerBtn not-active":"hamburgerBtn active"}>
                        <span></span>
                    </span>
                </div>
            </div>
            
        </header>       
    );
}

export default Header;